import { useQuery, QueryHookOptions, OperationVariables } from "@apollo/client";
import { ApiLegacyName } from "../../constants/apollo";

export const useLegacyQuery = <
  TData = any,
  TVariables extends OperationVariables = OperationVariables,
>(
  query: any,
  options?: QueryHookOptions<TData, TVariables>,
) => {
  const {
    fetchPolicy = "cache-first",
    onError,
    ...restOptions
  } = options || {};

  const legacyOptions = {
    ...restOptions,
    fetchPolicy: fetchPolicy,
    context: { api: ApiLegacyName.Legacy },
    onError,
  };

  return useQuery<TData, TVariables>(query, legacyOptions);
};
